module.exports = __webpack_public_path__ + "img/graden4.bbba287b.png";